import { booleanAttribute } from '@angular/core';

export const INPUT_TAB_INDEX = {
  INITIAL_VALUE: 0,
  TRANSFORM: (value?: unknown): number => (booleanAttribute(value) ? 0 : -1),
} as const;
